import { render } from "./Reminder.vue?vue&type=template&id=bd2019be"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__